var render, staticRenderFns
import script from "./list.vue?vue&type=script&lang=tsx&"
export * from "./list.vue?vue&type=script&lang=tsx&"
import style0 from "./list.vue?vue&type=style&index=0&id=3777dbeb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3777dbeb",
  null
  
)

export default component.exports